import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import GenerationHistory from './GenerationHistory'
import VersionHistory from './VersionHistory'

const AiImageHistoryTab = () => {
  const activeTimelineItemId = useSelector(editorSelectors.activeTimelineItemId)
  const showVersionHistoryTab = useSelector(
    aiImageSelectors.showVersionHistoryTab
  )
  const hasSelectedItem = !!activeTimelineItemId

  return hasSelectedItem || showVersionHistoryTab ? (
    <VersionHistory />
  ) : (
    <GenerationHistory />
  )
}

export default AiImageHistoryTab
